import Vue from 'vue'
import Vuex from 'vuex'
import repositories from '@/repositories/RepositoryFactory'
import {
  SET_ACCOUNT,
  SET_MENUS,
  SET_ANNOUNCEMENT,
  ENABLE_SEASON_FEATURE,
} from '@/const/mutation-types'
import { LOAD_BASIC_MASTERS } from '@/const/action-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // アカウント情報
    account: {
      userId: undefined,
    },
    // メニューマスタ（ログインユーザーが参照可能なメニューのみ）
    menus: [],
    // お知らせ
    announcement: {
      hasUnread: false,
    },
    // 個人設定
    preferences: {
      enableSeasonFeature: false,
    },
  },
  mutations: {
    [SET_ACCOUNT](state, { userId }) {
      state.account.userId = userId
    },
    [SET_MENUS](state, menus) {
      state.menus = menus
    },
    [SET_ANNOUNCEMENT](state, { hasUnread }) {
      state.announcement.hasUnread = hasUnread
    },
    [ENABLE_SEASON_FEATURE](state, value) {
      state.preferences.enableSeasonFeature = value
      try {
        if (value) {
          sessionStorage.setItem('enableSeasonFeature', '1')
        } else {
          sessionStorage.removeItem('enableSeasonFeature')
        }
      } catch (error) {}
    },
  },
  actions: {
    /**
     * 共通で必要となる（Storeに保存する）マスタをロードします。
     */
    async [LOAD_BASIC_MASTERS]({ commit }, { companyCode, loginId }) {
      // アカウント情報
      // const account = await repositories
      //   .get('account')
      //   .get(companyCode, loginId)
      // commit(SET_ACCOUNT, account)

      // メニュー
      const menus = await repositories.get('menu').get()
      commit(SET_MENUS, menus)
    },
  },
  // https://vuex.vuejs.org/ja/guide/strict.html
  strict: process.env.NODE_ENV === 'development',
})
